<template>
  <IconLink :href="supportFormURL" :target="target" :rel="rel">
    {{ hyperlinkText }}
  </IconLink>
</template>

<script>
import IconLink from "./IconLink.vue";

export default {
  components: {IconLink},
  props: {
    hyperlinkText: {
      type: String,
      default: () => {
        return "Contact Us"
      }
    },
    target: {
      type: String,
      default: () => {
        return "_blank"
      }
    },
    rel: {
      type: String,
      default: () => {
        return "noopener noreferrer"
      }
    },
  },
  data() {
    return {
      supportFormURL: 'https://docs.google.com/forms/d/e/1FAIpQLSc_K0CvacZRItpra4_O5npwjZZTYzAPHPidUxr4rVrDUf9EVg/viewform',
    }
  }
}
</script>
